import React from 'react';
import { Button, PopUp } from 'cantarus-react-ui';

const ConfirmationPopUp = ({ show, handleUserResponse, strings }) => {

    return (
        <PopUp
            title={strings.title}
            show={show}
            width="40%"
            togglePopUp={() => handleUserResponse(false)}
            classes={'confirmation'}
        >
            <div className='td-settings-popup-message'>
                <span>{strings.message}</span>
                {strings.subMessage && <p>{strings.subMessage}</p>}
                <hr />

                <Button classes={['secondary', 'template-settings-button']} text={strings.cancelButton} onClick={() => handleUserResponse(false)} />
                <Button classes={'template-settings-button'} text={strings.saveButton} onClick={() => handleUserResponse(true)} />
            </div>
        </PopUp>
    )
}

export default ConfirmationPopUp;
